import axios from "axios";
import { getToken, getTokenHeader } from "../../../../../screen/auth/action";
import { loginUrl } from "../urls";
import { deleteRegisterNotificationToken } from "../../../../../screen/distributor/action/util_action";
import { logoutAction } from "../../../../../screen/auth/action";
import store from "../../../../../utils/store";
import { toast } from "react-toastify";

let responseInterceptorId = null;
let isHandlingUnauthorized = false;

const redirectToLogin = () => {
  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};

const setup401ResponseInterceptor = () => {
  if (responseInterceptorId !== null) return;

  responseInterceptorId = axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error?.response?.status;

      if (status === 401 && !isHandlingUnauthorized) {
        isHandlingUnauthorized = true;
        toast.error("Session expired. Please connect with your firm owner");
        try {
          await store.store.dispatch(logoutUser());
        } catch (_e) {
          localStorage.clear();
          store.store.dispatch({ type: "LOGOUT" });
        } finally {
          setTimeout(() => {
            redirectToLogin();
            isHandlingUnauthorized = false;
          }, 1000); // Give user time to see the toast
        }
      }
      return Promise.reject(error);
    },
  );
};

setup401ResponseInterceptor();

export const LoginAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken(); 
    await axios
      .post(
        `${loginUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      }) 
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};

export const logoutUser = () => async (dispatch)  =>{
  const userToken = JSON.parse(localStorage.getItem('message_token'));
      await deleteRegisterNotificationToken(userToken);
      await logoutAction();
      localStorage.clear();
      dispatch({ type: 'LOGOUT' });
}
